"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("./browser");
const hashString_1 = require("./hashString");
const helpers_1 = require("./helpers");
/**
 * Note: Most of the code in this file was pulled from the ga.js
 * file. Some typing was added, some refactoring was done, but
 * generally it was left as-is.
 */
const generateClientId = () => {
    let a = browser_1.default.getWindow().navigator.userAgent
        + (browser_1.default.getDocument().cookie ? browser_1.default.getDocument().cookie : '')
        + (browser_1.default.getDocument().referrer ? browser_1.default.getDocument().referrer : '');
    let b = a.length;
    // tslint:disable: no-bitwise
    for (let c = browser_1.default.getWindow().history.length; 0 < c;) {
        a += c-- ^ b++;
    }
    return [helpers_1.default.generateRandomNumber() ^ hashString_1.default(a) & 2147483647, Math.round((new Date()).getTime() / 1E3)].join('.');
    // tslint:enable: no-bitwise
};
exports.default = generateClientId;
